export const ContributorsFragment = (postType: string): string => `
  fragment ContributorsFragment on ${postType} {
    contributors {
      types {
        key
        value {
          content
          featuredImage
          id
          slug
          social {
            key
            value
          }
          title
          career
        }
      }
    }
  }
`;
